import { registerLookup } from "@redriver/cinnamon";
import { getCustomers } from "./actions";

export const customersLookup = registerLookup("customersLookup", getCustomers);
